import React from 'react';
import { Stack } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	root: {
		paddingBlockStart: token('space.150'),
	},
});

export const TaskDescription = ({ children }: { children: React.ReactNode }): React.JSX.Element => {
	return (
		<Stack space="space.150" xcss={styles.root} alignInline="start">
			{children}
		</Stack>
	);
};
